module.exports = __webpack_public_path__ + "static/media/04-video-hotspot2.b8decfb0.png";